export default "__VITE_ASSET__BBOAc8Bb__"